module.exports = new __parcel__URL__("course_6.e89c2d14.jpg").toString();